module.exports = __webpack_public_path__ + "static/media/PatientsLaptop.30dcf33a.png";